import PropTypes from 'prop-types';
import React from 'react';

class MediaButton extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.preventDefault();
        this.props.handleClick();
    }

    render() {
        return (
            <button type="button" id={this.props.id} className={this.props.className} onClick={this.handleClick}>
                <icon className={this.props.icon} />
                <p className="photo-available is-util sr-text">{this.props.text}</p>
            </button>
        );
    }
}

MediaButton.defaultProps = {
    text: '',
    icon: '',
};

MediaButton.propTypes = {
    handleClick: PropTypes.func.isRequired,
    className: PropTypes.string.isRequired,
    id: PropTypes.string,
    icon: PropTypes.string,
    text: PropTypes.string,
};

export default MediaButton;
